/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { UseFormMethods, FormProvider } from "react-hook-form";

import { Sidebar } from "@nordcloud/gnui";

type Props = {
  open: boolean;
  setOpen: (value: boolean) => void;
  title: string;
  width?: string;
  formMethods: UseFormMethods;
  submit: (values: any) => void;
  children: React.ReactNode;
};

function SidebarForm(props: Props) {
  return (
    <Sidebar
      width={props.width || "30rem"}
      title={props.title}
      isOpen={props.open}
      onClick={() => props.setOpen(false)}
    >
      <FormProvider {...props.formMethods}>
        <form onSubmit={props.formMethods.handleSubmit(props.submit)}>
          {props.children}
        </form>
      </FormProvider>
    </Sidebar>
  );
}

export { SidebarForm };
